export enum WorkflowDetailsTableActionType {
  WORKFLOW_DETAILS_TABLE_EXPAND_STAGES = 'WORKFLOW_DETAILS_TABLE_EXPAND_STAGES',
  WORKFLOW_DETAILS_TABLE_COLLAPSE_STAGES = 'WORKFLOW_DETAILS_TABLE_COLLAPSE_STAGES',
  WORKFLOW_DETAILS_TABLE_TOGGLE_STAGE = 'WORKFLOW_DETAILS_TABLE_TOGGLE_STAGE',
}

export interface ExpandStagesAction {
  stageIds: Array<string>;
  type: WorkflowDetailsTableActionType.WORKFLOW_DETAILS_TABLE_EXPAND_STAGES;
}

export function expandStages(stageIds: Array<string>): ExpandStagesAction {
  return {
    type: WorkflowDetailsTableActionType.WORKFLOW_DETAILS_TABLE_EXPAND_STAGES,
    stageIds,
  };
}

export interface CollapseStagesAction {
  stageIds: Array<string>;
  type: WorkflowDetailsTableActionType.WORKFLOW_DETAILS_TABLE_COLLAPSE_STAGES;
}

export function collapseStages(stageIds: Array<string>): CollapseStagesAction {
  return {
    type: WorkflowDetailsTableActionType.WORKFLOW_DETAILS_TABLE_COLLAPSE_STAGES,
    stageIds,
  };
}

export interface ToggleStageAction {
  stageId: string;
  type: WorkflowDetailsTableActionType.WORKFLOW_DETAILS_TABLE_TOGGLE_STAGE;
}

export function toggleStage(stageId: string): ToggleStageAction {
  return {
    type: WorkflowDetailsTableActionType.WORKFLOW_DETAILS_TABLE_TOGGLE_STAGE,
    stageId,
  };
}

export type WorkflowDetailsTableAction = ExpandStagesAction | CollapseStagesAction | ToggleStageAction;
